import { render, staticRenderFns } from "./office-table-modal.vue?vue&type=template&id=4b3bf753&"
import script from "./office-table-modal.vue?vue&type=script&lang=js&"
export * from "./office-table-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports